var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import EditableToggle from './EditableToggle';
import adminpulse from '@/shared/utils/adminpulse';
var messages = defineMessages({
    InvalidEmail: {
        id: 'InvalidEmail',
        defaultMessage: 'Invalid email address',
    },
    FieldRequired: {
        id: 'FieldRequired',
        defaultMessage: 'This field is required',
    },
});
var EditableEmailTextbox = function (_a) {
    var onChange = _a.onChange, _b = _a.value, value = _b === void 0 ? null : _b, _c = _a.readOnly, readOnly = _c === void 0 ? false : _c, _d = _a.required, required = _d === void 0 ? false : _d, _e = _a.displayValue, displayValue = _e === void 0 ? null : _e, _f = _a.displayClassName, displayClassName = _f === void 0 ? '' : _f;
    var intl = useIntl();
    var _g = useState(''), error = _g[0], setError = _g[1];
    var handleSubmit = function (editValue) {
        if (!editValue && required) {
            setError(intl.formatMessage(messages.FieldRequired));
            return Promise.reject();
        }
        if (editValue && !adminpulse.isValidEmail(editValue)) {
            setError(intl.formatMessage(messages.InvalidEmail));
            return Promise.reject();
        }
        setError('');
        return onChange(editValue);
    };
    return (_jsx(EditableToggle, __assign({ onSubmit: handleSubmit, value: value, readOnly: readOnly, displayValue: displayValue, className: displayClassName, onModeChange: function (mode) {
            if (mode === 'display')
                setError('');
        } }, { children: function (_a) {
            var inputValue = _a.inputValue, handleChange = _a.handleChange, inputRef = _a.inputRef, submit = _a.submit, cancel = _a.cancel, handleKeyDown = _a.handleKeyDown;
            return (_jsxs("div", { children: [_jsx("input", { type: "email", value: inputValue === null ? '' : inputValue, onChange: function (e) {
                            setError('');
                            handleChange(e);
                        }, ref: inputRef, onBlur: submit, onKeyDown: handleKeyDown, className: "form-control".concat(error ? ' markedError' : ''), autoComplete: "off" }), error && _jsx("span", __assign({ className: "help-block text-danger" }, { children: error }))] }));
        } })));
};
export default EditableEmailTextbox;
